import React from 'react';
import moment from 'moment';
import { Typography, Row, Col } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';
import { ShiftCountByDayResponse } from '@scheduling/graphql';
import { Icon } from '@common/components';

const { Text } = Typography;

export function ShiftsCalendarDateCell({
  loading,
  shiftsCountByDay,
  date,
}: {
  loading: boolean;
  shiftsCountByDay: ShiftCountByDayResponse['shiftsCountByDay'] | [];
  date: moment.Moment;
}) {
  if (loading) {
    return <></>;
  }

  const shift = shiftsCountByDay.find((shift) => {
    if (shift['date'] === date.format('YYYY-MM-DD')) {
      return shift;
    }
  });

  if (!shift) {
    return <></>;
  }

  const hasDayOpenShifts = shift.openDayShiftsCount > 0;
  const hasNightOpenShifts = shift.openNightShiftsCount > 0;
  const hasConfirmedShifts = shift.confirmedShiftsCount > 0;

  return (
    <>
      <div style={{ marginTop: 8 }} className="date-cell">
        {hasDayOpenShifts && (
          <Row align="middle" className="shift-count">
            <Col>
              <Icon icon="sun" color="harvestGold" size="md" />
              <Text style={{ paddingLeft: 8 }}>
                {shift.openDayShiftsCount}
                {' open'}
              </Text>
            </Col>
          </Row>
        )}
        {hasNightOpenShifts && (
          <Row align="middle" className="shift-count">
            <Col>
              <Icon icon="moon" color="skyRegular" size="md" />
              <Text style={{ paddingLeft: 8 }}>
                {shift.openNightShiftsCount}
                {' open'}
              </Text>
            </Col>
          </Row>
        )}
        {hasConfirmedShifts && (
          <Row align="middle" className="shift-count">
            <Col>
              <Icon icon="check" color="midnightLightest" size="md" />
              <Text type="secondary" style={{ paddingLeft: 10 }}>
                {shift.confirmedShiftsCount}
                {' confirmed'}
              </Text>
            </Col>
          </Row>
        )}
      </div>
      <style jsx>{`
        :global(.shift-count) {
          padding-left: 8px;
        }
        :global(
          .ant-picker-calendar-full
            .ant-picker-panel
            .ant-picker-cell-selected
            .ant-picker-calendar-date
        ) {
          background-color: ${Colors.white};
        }
        :global(
          .ant-picker-calendar-full
            .ant-picker-panel
            .ant-picker-cell-selected
            .ant-picker-calendar-date
            > div
        ) {
          color: ${Colors.midnightDarkest} !important;
        }
        :global(
          .ant-picker-calendar-full
            .ant-picker-panel
            .ant-picker-cell-selected
            .ant-picker-calendar-date:hover
        ) {
          background-color: ${Colors.elmHyperlight} !important;
        }
        :global(.ShiftCalendar .ant-picker-calendar-date) {
          border-color: ${Colors.steel} !important;
        }
        :global(.ShiftCalendar .ant-picker-calendar-date-today) {
          border-top-width: 4px !important;
          border-color: ${Colors.elm} !important;
          background-color: ${Colors.white} !important;
        }
        :global(.ShiftCalendar .ant-picker-calendar-date-today:hover) {
          background-color: ${Colors.elmHyperlight} !important;
        }
        :global(
          .ShiftCalendar
            .ant-picker-calendar-date-today
            .ant-picker-calendar-date-value
        ) {
          font-weight: 700;
        }
        :global(.ShiftCalendar .ant-picker-calendar-date-value) {
          text-align: left;
          padding-left: 8px;
        }
        :global(
          .ShiftCalendar .ant-picker-content > tbody > tr > td:first-child > div
        ) {
          margin-left: 0;
        }
        :global(
          .ShiftCalendar .ant-picker-content > tbody > tr > td:last-child > div
        ) {
          margin-right: 0;
        }
      `}</style>
    </>
  );
}
